import { render, staticRenderFns } from "./iKnow.vue?vue&type=template&id=61f607fd&scoped=true&"
import script from "./iKnow.vue?vue&type=script&lang=js&"
export * from "./iKnow.vue?vue&type=script&lang=js&"
import style0 from "./iKnow.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./iKnow.vue?vue&type=style&index=1&id=61f607fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f607fd",
  null
  
)

export default component.exports